import { FIELD_PARENT_ACTIVITY_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { useGetCustomFieldsToLink } from "PFApp/hooks/activity_form/use_get_custom_fields_to_link";
import { usePropertyFieldValueChange } from "PFApp/hooks/activity_form/use_property_field_value_change";
import { CustomType, Profile, PureCustomValue, Subtemplate, Template } from "PFTypes";
import { useWatch } from "react-hook-form";

import { useEngagementTemplate } from "../use_engagement_template";
import { areValuesEqual } from "./helpers";

const cannotLinkResponse = { canLink: false, isLinked: false, restore: () => {} };

type UseCustomFieldLink = {
  template: Template;
  subtemplate: Subtemplate | null;
  activityCreator: Profile | null;
  customType: CustomType;
  value: PureCustomValue[];
};

export const useCustomFieldLink = ({
  template,
  subtemplate,
  activityCreator,
  customType,
  value
}: UseCustomFieldLink) => {
  const selectedParentActivity = useWatch({ name: FIELD_PARENT_ACTIVITY_KEY });
  const parentTemplate = useEngagementTemplate();
  const getLinkedCustomFields = useGetCustomFieldsToLink({ template, parentTemplate });

  const changePropertyFieldValue = usePropertyFieldValueChange({ template, subtemplate, activityCreator });

  if (!selectedParentActivity) {
    return cannotLinkResponse;
  }

  const linkedCustomFields = getLinkedCustomFields({
    engagement: selectedParentActivity,
    roleSubtemplate: subtemplate
  });

  const linkedCustomField = linkedCustomFields.find(({ type }) => type.name === customType.name);

  if (!linkedCustomField) {
    return cannotLinkResponse;
  }

  const isEqualToEngagementValue = areValuesEqual(linkedCustomField.values, value);

  return {
    isLinked: isEqualToEngagementValue,
    canLink: linkedCustomField.values.length > 0,
    restore: () => {
      changePropertyFieldValue(linkedCustomField.type.name, linkedCustomField.values);
    }
  };
};
